import { useTranslation } from 'react-i18next';
import useScrollReveal from '@/hooks/useScrollReveal';

const benefits = [
  { icon: 'ri-flask-line', key: 'protein', keyDesc: 'protein_desc' },
  { icon: 'ri-heart-pulse-line', key: 'lactose_free', keyDesc: 'lactose_free_desc' },
  { icon: 'ri-cup-line', key: 'no_sugar', keyDesc: 'no_sugar_desc' },
  { icon: 'ri-microscope-line', key: 'cultures', keyDesc: 'cultures_desc' },
  { icon: 'ri-map-pin-line', key: 'costa_rica', keyDesc: 'costa_rica_desc' },
  { icon: 'ri-hand-heart-line', key: 'artisanal', keyDesc: 'artisanal_desc' },
];

export default function BenefitsSection() {
  const { t } = useTranslation();
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section id="beneficios" className="py-20 md:py-28 bg-background-100 relative overflow-hidden">
      {/* Greek decorative background */}
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 opacity-[0.04]">
          <div className="w-px h-full bg-primary-400"></div>
        </div>
        <div className="absolute top-10 right-10 opacity-[0.05]">
          <div className="flex gap-2">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="w-10 h-10 border border-primary-400 rounded-full"></div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative max-w-[1200px] mx-auto px-6 md:px-10">
        <div ref={ref} className={`scroll-reveal text-center mb-16 ${isVisible ? 'visible' : ''}`}>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
            {t('benefits.title')}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
          {benefits.map((benefit, idx) => (
            <div
              key={benefit.key}
              className={`scroll-reveal group flex flex-col items-center text-center p-6 md:p-8 bg-background-50 rounded-2xl transition-all duration-500 hover:-translate-y-2`}
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-400">
                <i className={`${benefit.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-800 mb-2">
                {t(`benefits.${benefit.key}`)}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {t(`benefits.${benefit.keyDesc}`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}